import { HttpInterceptorFn } from '@angular/common/http';
import packageJson from '../../package.json';

export const VERSION_HEADER_NAME = 'Portal-Version';

/**
 * Version header interceptor to add the application version to the request headers.
 * Used to identify version mismatches between the frontend and backend.
 * @param req the request object to intercept
 * @param next the next interceptor in the chain
 * @returns the modified request with the version header added
 */
export const versionHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/api')) {
    // Merge existing headers with the new header
    const clonedRequest = req.clone({
      headers: req.headers.set(VERSION_HEADER_NAME, packageJson.version),
    });

    return next(clonedRequest);
  } else {
    return next(req);
  }
};
